import React,{ useEffect, useContext} from 'react';
import './sidemenu.css';
import { NavLink } from 'react-router-dom';
import { MdDashboard} from  'react-icons/md'
import { FaRegHandPaper} from 'react-icons/fa'
import {HiOutlineUserCircle} from 'react-icons/hi'
import { AiOutlineFileDone } from 'react-icons/ai'
import { GoGraph} from 'react-icons/go'
import Image2x from "../../assets/Image2x.png";
import Image2xSmall from "../../assets/IDFC_First_Bank_Small_logo.jpg";
import { UserContext } from '../../contexts/UserContext';

export default function SideMenu({location}) {
  const user = useContext(UserContext);
  const scrollLi = (e) => {
    document.getElementById("scrollli").style.top = ""+e.currentTarget.offsetTop+"px";
  } 

  setTimeout(() => {
    let el = document.getElementById("scrollli");
    if (el)
      el.style.top = "" + document.querySelector('li a.active')?.offsetTop + "px";
  }, 10)


  const role = user.roles;

  const isCAReport = role?.includes("ROLE_CA_REPORT");
  const isETCReport = role?.includes("ROLE_ETC_REPORT");
  const showConcess=role?.includes("ROLE_CONCESSIONAIRE");

  return (
    <div id="sidebar">
      <div className="smalllogo d-none" id="logo1">
      <img src={Image2xSmall} alt="logo" style={{width:39}} />
    </div>
    
      <div id="logo">
        <span className="tollplaza"> <img src={Image2x} alt="logo" className="logo" /></span>
        <div className="igia">{user?.fullname}</div>
      </div>
      <div id="items">
        <ul>
        {showConcess && 
        <li onClick={(e)=>{scrollLi(e)}}>
            <NavLink to="/dashboard/ConcessionaireDashboard">
              <MdDashboard/>
              <span className='sidebar-label'>Concessionaire Dashboard</span>
              <MdDashboard className="shortsidebaricon"/>
            </NavLink>
          </li>}
          <li onClick={(e)=>{scrollLi(e)}}>
            <NavLink to="/dashboard/dashboardwidgets">
              <MdDashboard/>
              <span className='sidebar-label'>Violation Dashboard</span>
              <MdDashboard className="shortsidebaricon"/>
            </NavLink>
          </li>
            <li onClick={(e)=>{scrollLi(e)}}>
              <NavLink to="/dashboard/CompleteViolations" >
                <FaRegHandPaper/>
                <span className='sidebar-label'>Complete Violation</span>
                <FaRegHandPaper className="shortsidebaricon"/>
              </NavLink>
            </li>
            <li onClick={(e)=>{scrollLi(e)}}>
              <NavLink to="/dashboard/violationforplazareviewListing" >
                <AiOutlineFileDone/>
                <span className='sidebar-label' >Pending For Unassigned</span>
                <AiOutlineFileDone className="shortsidebaricon"/>
              </NavLink>
            </li>
            <li onClick={(e)=>{scrollLi(e)}}>
              <NavLink to="/dashboard/assignedtomelisting" >
                <HiOutlineUserCircle/>
                <span className='sidebar-label'>Assigned To Me</span>
                <HiOutlineUserCircle className="shortsidebaricon"/>
              </NavLink>
            </li>
            <li onClick={(e)=>{scrollLi(e)}}>
            <NavLink to="/dashboard/violationAnaltics">
              <GoGraph/>
              <span className='sidebar-label'>Violation Analysis</span>
              <GoGraph className="shortsidebaricon"/>
            </NavLink>
            </li>
          {/* <li onClick={(e) => { scrollLi(e) }}>
            <NavLink to="/dashboard/raisedNewViolation">
              <FaRegHandPaper />
              Raised New Violation
              <FaRegHandPaper className="shortsidebaricon" />
            </NavLink>
          </li> */}
          <li onClick={(e) => { scrollLi(e) }}>
            <NavLink to="/dashboard/RaisedNewViolation">
              <FaRegHandPaper />
              <span className='sidebar-label'>Raise Violation / Refund</span>
              <FaRegHandPaper className="shortsidebaricon" />
            </NavLink>
          </li>
          {isCAReport && 
          <li onClick={(e)=>{scrollLi(e)}}>
              <NavLink to="/dashboard/RaisedCreditAdjustmentsScreen" >
                <FaRegHandPaper/>
                <span className='sidebar-label'>Raised Refund Status</span>
                <FaRegHandPaper className="shortsidebaricon"/>
              </NavLink>
            </li>}
            {isETCReport && 
            <li onClick={(e) => { scrollLi(e) }}>
            <NavLink to="/dashboard/ETCTATReport">
              <GoGraph/>
              <span className='sidebar-label'>ETC TAT (SLA) Report</span>
              <GoGraph className="shortsidebaricon"/>
            </NavLink>
          </li>}
          <li  className="scroll-li" id="scrollli">
           <a className=" selector-active" href="/#">&nbsp;<div className="top"></div><div className="bottom"></div></a>
           </li>
        </ul>
      </div>
    </div>
  )
}